<template>
  <article class="flex flex-col">
    <h1
      class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
    >
      Документы
    </h1>
    <CommonComplexFiltering
      v-if="false"
      class="mb-[20px]"
      :rubrics-list="documentRubrics?.data?.value"
      is-centuries-disabled
      :filters-active="filters"
    />
    <div
      class="grid grid-cols-1 gap-[20px] md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6"
    >
      <MainPageCardsReworkedDocumentsCard
        v-for="documentCategory in documents?.data?.value"
        :key="documentCategory.id"
        class="col-span-1 min-h-[401px]"
        :data="getDocumentsCategoryCardData(documentCategory)"
      />
    </div>
  </article>
</template>

<script setup>
const EXCLUDE_CATEGORIES = [33]; // Исключена отдельная категория "Z-files", для отрисовки на отдельной странице.. 13.10.2026
const route = useRoute();

const filters = computed(() => {
  return {
    categories: route.query?.category,
    exclude: EXCLUDE_CATEGORIES,
  };
});

const { documents: documentRubrics } = useDocuments();
const { documents } = useDocuments(filters);

const getDocumentsCategoryCardData = (category) => {
  return {
    title: category.title,
    url: `/read/documents/${category.slug}`,
    image: category.documents?.[0]?.images?.[0],
  };
};

const { canonicalUrl, title } = useSeoHelper();

useHead(() => ({
  title: title(
    'Исторические документы РФ | Читать на Федеральном портале Истории России',
  ),
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'Документы, подтверждающие или описывающие реальные события Российской истории из первых уст. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl.value,
    },
  ],
}));
</script>
